import { render, staticRenderFns } from "./PlacasMaisAtendidas.vue?vue&type=template&id=188b3008&scoped=true&"
import script from "./PlacasMaisAtendidas.vue?vue&type=script&lang=js&"
export * from "./PlacasMaisAtendidas.vue?vue&type=script&lang=js&"
import style0 from "./PlacasMaisAtendidas.vue?vue&type=style&index=0&id=188b3008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b3008",
  null
  
)

export default component.exports